import Vue from 'vue'
import {
  DxDropDownBox,
  DxTreeView,
  DxSelectBox,
  DxAutocomplete,
  DxForm,
  DxDataGrid,
  DxPopup,
  DxList,
  DxButton,
  DxHeaderFilter,
  DxFilterRow,
  DxFilterPanel,
  DxFilterBuilderPopup,
  DxScrolling,
  DxTextBox,
  DxTextArea,
  DxPaging } from 'devextreme-vue'

import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.compact.css'
import 'devextreme-intl'
import 'devextreme/dist/js/localization/dx.messages.pt'
import ptMessage from 'devextreme/localization/messages/pt'
import { locale, loadMessages } from 'devextreme/localization'

require('devextreme/dist/js/dx.all')

Vue.component('dx-autocomplete', DxAutocomplete)
Vue.component('dx-data-grid', DxDataGrid)
Vue.component('dx-form', DxForm)
Vue.component('dx-popup', DxPopup)
Vue.component('dx-list', DxList)
Vue.component('dx-button', DxButton)
Vue.component('dx-headerfilter', DxHeaderFilter)
Vue.component('dx-filter-row', DxFilterRow)
Vue.component('dx-filter-panel', DxFilterPanel)
Vue.component('dx-filter-builder-popup', DxFilterBuilderPopup)
Vue.component('dx-scrolling', DxScrolling)
Vue.component('dx-text-box', DxTextBox)
Vue.component('dx-text-area', DxTextArea)
Vue.component('dx-paging', DxPaging)
Vue.component('dx-select-box', DxSelectBox)
Vue.component('dx-drop-down-box', DxDropDownBox)
Vue.component('dx-tree-view', DxTreeView)

loadMessages(ptMessage)
locale('pt')
